import { pagerRange } from '../lib/pager.js';

/**
 * ehr#477: the notes pager ("Showing 1–15 of 40 notes", ‹ 1 2 3 ›), the same markup and
 * classes as the Progress Notes table's. Shows nothing while everything fits on one page.
 */
export function Pager({
  page,
  totalPages,
  first,
  last,
  total,
  noun = 'notes',
  className = '',
  onPage,
}: {
  page: number;
  totalPages: number;
  first: number;
  last: number;
  total: number;
  noun?: string;
  className?: string;
  onPage: (n: number) => void;
}) {
  if (totalPages <= 1) return null;
  return (
    <div className={`pager${className ? ` ${className}` : ''}`}>
      <div className="pager-count">
        Showing{' '}
        <strong>
          {first}–{last}
        </strong>{' '}
        of <strong>{total}</strong> {noun}
      </div>
      <div className="pager-pages">
        <button
          type="button"
          className="pager-btn"
          disabled={page === 1}
          onClick={() => onPage(page - 1)}
          aria-label="Previous page"
        >
          ‹
        </button>
        {pagerRange(page, totalPages).map((n, i) =>
          n === '…' ? (
            <span className="pager-gap" key={`gap-${i}`}>
              …
            </span>
          ) : (
            <button
              type="button"
              key={n}
              className={`pager-btn${n === page ? ' active' : ''}`}
              onClick={() => onPage(n)}
              aria-current={n === page ? 'page' : undefined}
              aria-label={`Page ${n}`}
            >
              {n}
            </button>
          ),
        )}
        <button
          type="button"
          className="pager-btn"
          disabled={page === totalPages}
          onClick={() => onPage(page + 1)}
          aria-label="Next page"
        >
          ›
        </button>
      </div>
    </div>
  );
}
